export const __DEV__ = import.meta.env.DEV;
